import type { MRT_ColumnDef } from "mantine-react-table-open";
import { backendDateOrDateTimeToLuxonDateTime } from "../../../../utils/dates/backendDateOrDateTimeToLuxonDateTime";
import { TodoDueDateCell } from "../Cells/TodoDueDateCell";
import {
  isNotChangeable,
  OVERDUE_DATE,
  type TodoTableTodo
} from "../TodoTable";

function getDueDateColumn(
  allDueDates: Array<string>,
  onChangeDueDate: (todoId: number, newDueDate: string | null) => void,
  onChangeOverdue: (todoId: number, newOverdue: boolean) => void
): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Fälligkeit",
    accessorKey: "dueDate",
    accessorFn: (todo: TodoTableTodo) => {
      if (todo.dueDate === null || todo.dueDate === OVERDUE_DATE) {
        return "01.01.1970";
      }
      return todo.dueDate;
    },
    size: 250,
    sortingFn: "datetime",
    filterVariant: "multi-select",
    mantineFilterMultiSelectProps: { data: ["Überfällig", ...allDueDates] },
    filterFn: (row, id, filterValues) => {
      if (filterValues.length === 0) {
        return true;
      }
      if (
        filterValues.includes("Überfällig") &&
        row.getValue(id) === OVERDUE_DATE
      ) {
        return true;
      }
      return filterValues.includes(row.getValue(id));
    },
    Cell: ({ row }) => (
      <TodoDueDateCell
        dueDate={
          row.original.dueDate && row.original.dueDate !== "-1"
            ? backendDateOrDateTimeToLuxonDateTime(row.original.dueDate)
            : undefined
        }
        notChangeable={isNotChangeable(row.original)}
        overdue={row.original.overdue}
        todoId={row.original.id}
        onChangeDueDate={onChangeDueDate}
        onChangeOverdue={onChangeOverdue}
      />
    )
  };
}

export { getDueDateColumn };
